import {
  exportDailySalesReport,
  fetchDailySalesReport,
  fetchPaymentMixReport,
} from '@/lib/api/reports'
import { resolveReportPeriodBounds } from '@/lib/reports/filters'

/**
 * @param {{ period: string, customFrom?: string, customTo?: string }} options
 */
export function buildSalesReportQuery(options) {
  const { period, customFrom = '', customTo = '' } = options

  if (period === 'custom') {
    return {
      period: 'custom',
      from: customFrom,
      to: customTo,
    }
  }

  const bounds = resolveReportPeriodBounds(period)
  return {
    period,
    from: bounds.from,
    to: bounds.to,
  }
}

/**
 * Sales + payment mix for the selected period.
 *
 * @param {{ period: string, customFrom?: string, customTo?: string }} options
 */
export async function fetchSalesReportForPeriod(options) {
  const query = buildSalesReportQuery(options)

  const [sales, paymentMix] = await Promise.all([
    fetchDailySalesReport(query),
    fetchPaymentMixReport(query),
  ])

  return { sales, paymentMix, query }
}

/**
 * @param {{ period: string, customFrom?: string, customTo?: string }} options
 */
export async function exportSalesReportCsv(options) {
  const query = buildSalesReportQuery(options)
  await exportDailySalesReport('csv', query)
}

/**
 * @deprecated Use fetchSalesReportForPeriod
 */
export async function fetchSalesSummary() {
  return fetchSalesReportForPeriod({ period: 'today' })
}

/**
 * @deprecated Use exportSalesReportCsv
 */
export async function exportSalesCsv(options = {}) {
  await exportSalesReportCsv({
    period: options.period ?? 'week',
    customFrom: options.customFrom,
    customTo: options.customTo,
  })
}
